import $ from 'jquery'
import Foundation from 'foundation-sites'
import React from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import App from './app.jsx'

if (typeof window !== 'undefined') {
  window.jQuery = window.$ = $

  $(document).ready(() => {
    $(document).foundation()
  })

  if (import.meta.env.PROD) {
    const script = document.createElement('script')
    script.defer = true
    script.src = 'https://keybreak-analytics.fly.dev/script.js'
    script.dataset.websiteId = 'e77c7c17-c0ee-4a3c-9cb9-e2222fc78f2f'
    document.head.appendChild(script)

  }

  const container = document.getElementById('root')
  if (container.children.length > 0) {
    hydrateRoot(container, <App />)
  } else {
    createRoot(container).render(<App />)
  }
}
